export enum Ring {
  Zero,
  One,
  Two,
  Three,
}
